import { render, staticRenderFns } from "./DesktopTileCard.vue?vue&type=template&id=c2069e86&"
import script from "./DesktopTileCard.vue?vue&type=script&lang=js&"
export * from "./DesktopTileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports